export const isMobile = () => window.matchMedia('(any-pointer:coarse)').matches;
